module.exports = __webpack_public_path__ + "static/media/retirement-small.bff966ed.webp";